// src/components/Layout/PageSkeleton.jsx
import React from "react";
import { Container, Row, Col, Placeholder } from "react-bootstrap";

const PageSkeleton = () => {
  return (
    <Container className="page-skeleton">
      <Row className="mb-4">
        <Col md={6}>
          <Placeholder as="h2" animation="wave">
            <Placeholder xs={8} />
          </Placeholder>
          <Placeholder as="p" animation="wave" className="mt-3">
            <Placeholder xs={12} />
            <Placeholder xs={10} />
            <Placeholder xs={6} />
          </Placeholder>
        </Col>
        <Col md={6}>
          <Placeholder animation="wave" className="w-100 skeleton-box" />
        </Col>
      </Row>

      <Row>
        <Col md={4} className="mb-3">
          <Placeholder animation="wave" className="w-100 skeleton-card" />
        </Col>
        <Col md={4} className="mb-3">
          <Placeholder animation="wave" className="w-100 skeleton-card" />
        </Col>
        <Col md={4} className="mb-3">
          <Placeholder animation="wave" className="w-100 skeleton-card" />
        </Col>
      </Row>
    </Container>
  );
};

export default PageSkeleton;
